import { render } from "./Navigation.vue?vue&type=template&id=be2a2df4&scoped=true"
import script from "./Navigation.vue?vue&type=script&lang=js"
export * from "./Navigation.vue?vue&type=script&lang=js"

import "./Navigation.vue?vue&type=style&index=0&id=be2a2df4&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-be2a2df4"

export default script